import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { MatSelectChange } from '@angular/material/select'

import { IStyle } from '../../../Interface/style'
import { I18nService, LgType } from '../../../services/prod/i18n.service'
import { TracksService } from '../../../services/tracks.service'
import { FilterPropertyType, IdType } from '../../../types/filter.type'

@Component({
  selector: 'bmcore-style-select',
  templateUrl: './bmcore-style-select.component.html',
  styleUrls: ['./bmcore-style-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreStyleSelectComponent implements OnInit {
  @Input() styleId: IdType
  @Output() filterTracksEvent = new EventEmitter<FilterPropertyType>()

  lg: LgType
  styles: IStyle[] = []

  constructor(
    private i18nService: I18nService,
    private tracksService: TracksService
  ) {}

  ngOnInit(): void {
    this.lg = this.i18nService.getLanguageForPage()
    this.tracksService.Styles.subscribe(res => (this.styles = res))
  }

  filterTracksByStyle(matEvent: MatSelectChange) {
    this.filterTracksEvent.emit({ title: 'style', id: matEvent.value })
  }

  getStyles(): IStyle[] {
    return this.styles
  }
}
